<template>
  <div>
    <Pane />
    <a-card class="container">
      <a-form-model layout="inline" @keyup.enter.native="query">
        <a-form-model-item label="工单类型">
          <a-select v-model="queryForm.workType" placeholder="全部" style="width: 160px" allowClear>
            <a-select-option v-for="item in workTypeList" :key="item" :value="item">
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="涉及模块">
          <a-select v-model="queryForm.workModule" placeholder="全部" style="width: 160px" allowClear>
            <a-select-option v-for="item in queryWorkModuleList" :key="item" :value="item">
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="申请分类">
          <a-select
            v-model="queryForm.applyCategory"
            placeholder="全部"
            style="width: 200px"
            show-search
            option-filter-prop="children"
            allowClear
          >
            <a-select-option v-for="item in queryApplyCategoryList" :key="item" :value="item">
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-space>
            <a-button type="primary" @click="query">查询</a-button>
            <a-button @click="reset">重置</a-button>
            <a-button type="primary" @click="openModal()">新增配置</a-button>
          </a-space>
        </a-form-model-item>
      </a-form-model>

      <Padding />

      <a-table
        bordered
        :columns="columns"
        :dataSource="list"
        :loading="loading"
        @change="onChange"
        :pagination="{
          total,
          current,
          pageSize,
          showTotal: (total) => `共 ${total} 条记录`,
        }"
      >
        <template slot="handlerCol" slot-scope="text, record">
          <span>{{ (record.handlerNames || '').split('，').join('、') }}</span>
        </template>
        <template slot="sortCol" slot-scope="text">
          <span>{{ text == null ? 0 : text }}</span>
        </template>
        <template slot="leaderCol" slot-scope="text">
          <!-- isLeaderReview=true需要部门领导审批，false/空不需要 -->
          <a-tag :color="text ? 'blue' : 'default'">{{ text ? "是" : "否" }}</a-tag>
        </template>
        <template slot="availCol" slot-scope="text">
          <!-- isDeleted=false可用，true不可用（软删除） -->
          <a-tag :color="text ? 'red' : 'green'">{{ text ? "不可用" : "可用" }}</a-tag>
        </template>
        <template slot="updateAtCol" slot-scope="text">
          <span>{{ text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : "" }}</span>
        </template>
        <template slot="actionCol" slot-scope="text, record">
          <a-space>
            <a href="#" @click.prevent="openModal(record)">编辑</a>
            <!-- 可用→停用，停用→启用 -->
            <a
              href="#"
              :class="{ danger: !record.isDeleted }"
              @click.prevent="toggle(record)"
            >{{ record.isDeleted ? "启用" : "停用" }}</a>
          </a-space>
        </template>
      </a-table>
    </a-card>

    <!-- 新增/编辑弹窗 -->
    <a-modal
      :title="modalForm.id ? '编辑配置' : '新增配置'"
      :visible="modalVisible"
      :confirm-loading="modalLoading"
      :width="640"
      @ok="submitModal"
      @cancel="modalVisible = false"
    >
      <a-form-model
        ref="modalFormRef"
        :model="modalForm"
        :rules="modalRules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="工单类型" prop="workType">
          <a-select
            v-model="modalForm.workType"
            :disabled="!!modalForm.id"
            placeholder="请选择工单类型"
            @change="onTypeChange"
            allowClear
          >
            <a-select-option v-for="item in workTypeList" :key="item" :value="item">
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="涉及模块" prop="workModule">
          <a-select
            v-model="modalForm.workModule"
            :disabled="!!modalForm.id"
            placeholder="请选择涉及模块"
            @change="onModuleChange"
            allowClear
          >
            <a-select-option v-for="item in workModuleList" :key="item" :value="item">
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="申请分类" prop="applyCategory">
          <a-auto-complete
            v-model="modalForm.applyCategory"
            :disabled="!!modalForm.id"
            :data-source="applyCategoryList"
            placeholder="选择从属分类或输入新分类"
            allowClear
          />
        </a-form-model-item>
        <!-- 处理部门表单去除：选择处理人时自动带入第一个人的部门（onSelectHandlers） -->
        <!--
        <a-form-model-item label="处理部门" prop="handlerDeptId">
          <a-select
            v-model="modalForm.handlerDeptId"
            placeholder="请选择处理部门"
            show-search
            option-filter-prop="children"
            @change="onDeptChange"
            allowClear
          >
            <a-select-option v-for="item in orgList" :key="item.id" :value="item.id">
              {{ item.uniqueName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        -->
        <a-form-model-item label="处理人" prop="handlerIds">
          <EmployeeSelector :single="false" @change="onSelectHandlers" :value="selectedHandlers">
            <a-button block style="text-align: left">
              {{
                selectedHandlers.length
                  ? selectedHandlers.map(handlerLabel).join("、")
                  : "请选择处理人"
              }}
            </a-button>
          </EmployeeSelector>
        </a-form-model-item>
        <a-form-model-item label="排序">
          <a-input-number v-model="modalForm.sort" :min="0" style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item label="部门领导审批">
          <!-- 是否需要部门领导审批：开启后工单审批流程传入is_leader_review=true，BPMN按此分流 -->
          <a-switch
            v-model="modalForm.isLeaderReview"
            checked-children="需要"
            un-checked-children="不需要"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import moment from "moment";
import watermark from "@/mixins/watermark";
import EmployeeSelector from "@/components/employee-selector";
import { fetchList as fetchOrgList } from "@/api/setting/organization";
import {
  fetchConfigList,
  fetchConfigAll,
  addConfig,
  updateConfig,
  toggleConfig,
} from "@/api/oa/workOrder";

export default {
  name: "workOrderConfig",
  mixins: [watermark],

  components: { EmployeeSelector },

  data() {
    return {
      loading: false,
      queryForm: {},
      current: 1,
      pageSize: 10,
      list: [],
      total: 0,
      allConfigs: [],
      orgList: [],
      modalVisible: false,
      modalLoading: false,
      modalForm: {},
      selectedHandlers: [],
      modalRules: {
        workType: [{ required: true, message: "请选择工单类型" }],
        workModule: [{ required: true, message: "请选择涉及模块" }],
        applyCategory: [{ required: true, message: "请选择或输入申请分类" }],
        // handlerDeptId: [{ required: true, message: "请选择处理部门" }],  // 处理部门由选人自动带入
        handlerIds: [{ required: true, message: "请选择处理人" }],
      },
      columns: [
        { title: "工单类型", dataIndex: "workType", align: "center", width: 140 },
        { title: "涉及模块", dataIndex: "workModule", align: "center", width: 140 },
        { title: "申请分类", dataIndex: "applyCategory", align: "center", width: 160 },
        { title: "处理部门", dataIndex: "handlerDeptName", align: "center", width: 160 },
        {
          title: "处理人",
          dataIndex: "handlerNames",
          align: "center",
          width: 200,
          scopedSlots: { customRender: "handlerCol" },
        },
        { title: "排序", dataIndex: "sort", align: "center", width: 80, scopedSlots: { customRender: "sortCol" } },
        { title: "部门领导审批", dataIndex: "isLeaderReview", align: "center", width: 110, scopedSlots: { customRender: "leaderCol" } },
        { title: "是否可用", dataIndex: "isDeleted", align: "center", width: 90, scopedSlots: { customRender: "availCol" } },
        { title: "更新时间", dataIndex: "updateAt", align: "center", width: 160, scopedSlots: { customRender: "updateAtCol" } },
        {
          title: "操作",
          align: "center",
          width: 120,
          scopedSlots: { customRender: "actionCol" },
        },
      ],
    };
  },

  computed: {
    workTypeList() {
      return [...new Set(this.allConfigs.map((c) => c.workType).filter(Boolean))];
    },
    // 涉及模块从属于所选工单类型（弹窗表单）
    workModuleList() {
      return [
        ...new Set(
          this.allConfigs
            .filter((c) => c.workType === this.modalForm.workType)
            .map((c) => c.workModule)
            .filter(Boolean)
        ),
      ];
    },
    // 申请分类从属于所选工单类型+涉及模块（弹窗表单，可输入新分类）
    applyCategoryList() {
      return [
        ...new Set(
          this.allConfigs
            .filter(
              (c) =>
                c.workType === this.modalForm.workType &&
                c.workModule === this.modalForm.workModule
            )
            .map((c) => c.applyCategory)
            .filter(Boolean)
        ),
      ];
    },
    // 查询区独立的联动下拉（按queryForm过滤，与弹窗modalForm隔离）
    queryWorkModuleList() {
      return [
        ...new Set(
          this.allConfigs
            .filter((c) => c.workType === this.queryForm.workType)
            .map((c) => c.workModule)
            .filter(Boolean)
        ),
      ];
    },
    queryApplyCategoryList() {
      return [
        ...new Set(
          this.allConfigs
            .filter(
              (c) =>
                c.workType === this.queryForm.workType &&
                c.workModule === this.queryForm.workModule
            )
            .map((c) => c.applyCategory)
            .filter(Boolean)
        ),
      ];
    },
  },

  mounted() {
    this.getList();
    this.getAllConfigs();
    fetchOrgList({ status: 1 }).then((res) => {
      this.orgList = Array.isArray(res) ? res : res.list || [];
    });
  },

  methods: {
    // 供模板格式化时间使用
    moment,
    getList() {
      const { current, pageSize, queryForm } = this;
      this.loading = true;
      fetchConfigList({
        pageNum: current,
        pageSize,
        ...queryForm,
      })
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res.list)) {
            this.list = res.list;
            this.total = res.totalSize;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getAllConfigs() {
      fetchConfigAll().then((res) => {
        this.allConfigs = Array.isArray(res) ? res : [];
      });
    },
    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },
    query() {
      this.current = 1;
      this.getList();
    },
    reset() {
      this.queryForm = {};
      this.current = 1;
      this.getList();
    },
    // 打开新增/编辑弹窗
    openModal(record) {
      this.modalForm = record
        ? {
            id: record.id,
            workType: record.workType,
            workModule: record.workModule,
            applyCategory: record.applyCategory,
            handlerDeptId: record.handlerDeptId,
            handlerDeptName: record.handlerDeptName,
            handlerIds: record.handlerIds,
            handlerNames: record.handlerNames,
            sort: record.sort,
            isLeaderReview: !!record.isLeaderReview,
          }
        // 新增时也必须预置全部字段（值为undefined）：Vue2无法侦测后加的属性，
        // 否则选中工单类型后modalForm.workType非响应式，workModuleList不联动导致涉及模块选不中
        : {
            id: undefined,
            workType: undefined,
            workModule: undefined,
            applyCategory: undefined,
            handlerDeptId: undefined,
            handlerDeptName: undefined,
            handlerIds: undefined,
            handlerNames: undefined,
            sort: 0,
            isLeaderReview: false,
          };
      this.selectedHandlers = record && record.handlerIds
        ? record.handlerIds.split(",").map((id, index) => ({
            // handlerIds存的是userId（tb_user.uuid），回显时userId/id都置为该值以兼容选择器匹配
            userId: id.trim(),
            id: id.trim(),
            name: (record.handlerNames || "").split(",")[index]
              ? record.handlerNames.split(",")[index].trim()
              : id.trim(),
            // 回显部门信息：配置约束处理人同部门，直接用记录上的部门；与选择器候选项字段结构保持一致
            deptId: record.handlerDeptId,
            deptUniqueName: record.handlerDeptName || "",
          }))
        : [];
      this.modalVisible = true;
      this.$nextTick(() => {
        this.$refs.modalFormRef && this.$refs.modalFormRef.clearValidate();
      });
    },
    onDeptChange(deptId) {
      // 处理部门表单已去除，部门由选人自动带入；方法注释保留
      // const dept = this.orgList.find((item) => item.id === deptId);
      // this.modalForm.handlerDeptName = dept ? dept.uniqueName : "";
    },
    // 工单类型变化时清空下级（涉及模块/申请分类），保证从属关系
    onTypeChange() {
      this.modalForm.workModule = undefined;
      this.modalForm.applyCategory = undefined;
    },
    // 涉及模块变化时清空下级申请分类
    onModuleChange() {
      this.modalForm.applyCategory = undefined;
    },
    // 选择处理人（所有处理人必须同部门；部门取选中处理人的部门并更新表单字段）
    onSelectHandlers(arr) {
      const list = arr || [];
      // 部门字段在候选项平级字段上：deptId/deptUniqueName（employeeOrgVo只有排序用的sort，没有id/name）
      const deptKey = (i) => i.deptId || "";
      const deptIds = [...new Set(list.map(deptKey).filter(Boolean))];
      if (deptIds.length > 1) {
        this.$message.warning("处理人必须属于同一部门，请重新选择");
        return;
      }
      // handlerIds存userId（tb_user.uuid）；选择器项的id是员工表id（0001N开头），不能用于流程assignee
      this.modalForm.handlerIds = list.map((i) => i.userId).join(",");
      this.modalForm.handlerNames = list.map((i) => i.name).join(",");
      const deptId = list.length ? list[0].deptId || "" : "";
      const deptName = list.length ? list[0].deptUniqueName || "" : "";
      if (deptId) {
        this.modalForm.handlerDeptId = deptId;
        this.modalForm.handlerDeptName = deptName;
      } else if (list.length === 0) {
        this.modalForm.handlerDeptId = undefined;
        this.modalForm.handlerDeptName = undefined;
      }
      // 部门名固化到项上供"部门-处理人"显示
      this.selectedHandlers = list.map((i) => ({
        ...i,
        deptName: i.deptUniqueName || this.modalForm.handlerDeptName || "",
      }));
    },
    // 处理人显示格式：部门-姓名（无部门信息时只显示姓名）
    handlerLabel(item) {
      return (item.deptName ? item.deptName + "-" : "") + item.name;
    },
    submitModal() {
      this.$refs.modalFormRef.validate((valid) => {
        if (!valid) return;
        this.modalLoading = true;
        const req = {
          id: this.modalForm.id,
          workType: this.modalForm.workType,
          workModule: this.modalForm.workModule,
          applyCategory: this.modalForm.applyCategory,
          handlerDeptId: this.modalForm.handlerDeptId,
          handlerDeptName: this.modalForm.handlerDeptName,
          handlerIds: this.modalForm.handlerIds,
          handlerNames: this.modalForm.handlerNames,
          sort: this.modalForm.sort,
          isLeaderReview: !!this.modalForm.isLeaderReview,
        };
        const ask = this.modalForm.id ? updateConfig : addConfig;
        ask(req)
          .then(() => {
            this.modalLoading = false;
            this.modalVisible = false;
            this.$message.success("保存成功");
            this.getList();
            this.getAllConfigs();
          })
          .catch(() => {
            this.modalLoading = false;
          });
      });
    },
    // 启用/停用切换：可用→停用，停用→启用
    toggle(record) {
      const _this = this;
      const disabling = !record.isDeleted;
      const configName = `【${record.workType} - ${record.workModule}${
        record.applyCategory ? " - " + record.applyCategory : ""
      }】`;
      this.$confirm({
        title: disabling ? "停用确认" : "启用确认",
        content: disabling
          ? `确定停用配置${configName}吗？停用后发起工单将不再匹配该配置。`
          : `确定启用配置${configName}吗？`,
        onOk() {
          return toggleConfig(record.id).then(() => {
            _this.$message.success(disabling ? "已停用" : "已启用");
            _this.getList();
            _this.getAllConfigs();
          });
        },
      });
    },
  },
};
</script>
